import React from "react";
import { social } from "../data";

const Socials = () => {
    return (
        <div className="md:hidden ">
            <ul className="flex flex-row w-64 gap-16 py-6 justify-evenly ">
                {social.map((item, index) => {
                    return (
                        <li
                            className="flex justify-center items-center text-greenAccent hover:text-accent transition-all duration-300 ease-in-out"
                            key={index}
                        >
                            <a className="text-base" href={item.href}>
                                {item.icon}
                            </a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default Socials;
